var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"float-navbar"},[_c('p',{staticClass:"float-navbar__title"},[_vm._v("浮动导航栏")]),_c('p',{staticClass:"float-navbar__subtitle"},[_vm._v(" 顶部透明导航栏，当页面滚动时悬浮并变不透明，此模块无须预览，提供占位即可。 ")])])
}]

export { render, staticRenderFns }